module.exports = __webpack_public_path__ + "static/media/zhihuishiyongchangjing.7285637d.mp4";